import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import DashConsumoContratual from "../classes/DashConsumoContratual";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "DashboardConsumoContratual" },
  { method: "GET", rota: "DashboardConsumoContratual/ContratosSap" },
];

const cacheKey: string = "DashboardConsumoContratual";
const cacheKeySelC: string = "DashboardConsumoContratualSelecionado";

const apiServico: string = "DASHBOARD";

export default class DashConsumoContratualDataset extends httpClient {
  
  constructor() {
    super(apiServico);
  }

  async listarContratosSap(
    codigoFornecedorSap: number
    ): Promise<string[]> {
      let ok: boolean = false;
      let data: string[];
      let error: any = undefined;
      
      await super
      .Get(`${calls[1].rota}?codFornecedorSap=${codigoFornecedorSap}`)
      .then((response: AxiosResponse) => {
        ok = response.status === 200;
        data = response.data;
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<string[]>((resolve) => {
      resolve(data);
    });
  }

  async getAll(
    idParceiro?: number,
    contratoSap?: String[],
    contratoPortal?: String[],
    sku?: String[]
  ): Promise<DashConsumoContratual[]> {
    let ok: boolean = false;
    let data: DashConsumoContratual[];
    let error: any = undefined;

    let params = `Parceiro=${idParceiro}`;
    sku?.forEach(x=> params += `&sku=${x}`);
    contratoSap?.forEach(x=> params += `&contratoSap=${x}`);
    contratoPortal?.forEach(x=> params += `&contratoPortal=${x}`);

    await super
      .Get(`${calls[0].rota}?${params}`)
      .then((response: AxiosResponse) => {
        ok = response.status === 200;
        data = DashConsumoContratual.fromJson(response.data);
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<DashConsumoContratual[]>((resolve) => {
      resolve(DashConsumoContratual.fromJson(data));
    });
  }

  getKeyCache(): string {
    return cacheKey;
  }

  getKeyCacheSelected(): string {
    return cacheKeySelC;
  }

  getAllFromCache(): DashConsumoContratual[] {
    let result: DashConsumoContratual[] = JSON.parse(cacheKey);
    return result;
  }

  addResultsToCache(value: DashConsumoContratual[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  clearCache() {
    localStorage.removeItem(cacheKey);
  }

  clearSelectedItemFromCache() {
    localStorage.removeItem(cacheKeySelC);
  }

}
